import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminAllPayments = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Payments</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>ID</th>
                            <th>Method</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>COD</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Stripe</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>PayPal</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>PayTM</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>RazorPay</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>InstaMOJO</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>PayStack</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>Flutterwave</td>
                            <td>
                              <span className="badge bg-success">Active</span>
                            </td>
                            <td>
                              <button className="btn btn-primary btn-sm">
                                Edit
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminAllPayments;
